<template>
  <div>
    <div class="newslist is-size-5" v-for="item in getItems" v-bind:key="item.id">
      <label class="checkbox">
        <input type="checkbox" disabled v-bind:checked="item.done === '1'">
        <router-link :to="{ name: 'details', params: { news: item.news_id, group: group } }">
          {{ item.title }} 
          <template v-if="item.isNotPostingTerm !== '1'">
            ({{ item.upDate }})
          </template>
        </router-link>
      </label>
    </div>
    <nav class="pagination is-centered" role="navigation" aria-label="pagination">
      <paginate
        v-model="page.currentPage"
        :page-count="getPageCount"
        :page-range="3"
        :margin-pages="2"
        :click-handler="clickCallback"
        :prev-text="'前'"
        :next-text="'次'"
        :container-class="'pagination-list'"
        :page-link-class="'pagination-link'"
        :page-class="''"
        :hide-prev-next="true"
        :prev-link-class="'pagination-previous'"
        :next-link-class="'pagination-next'"
        :active-class="'pagination-link is-current'"
        :no-li-surround="true">
      </paginate>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState} from 'vuex'
import Paginate from 'vuejs-paginate'

export default {
  data: function(){
    return {
      page: {
        parPage: 7,
        currentPage: 1
      }
    }
  },
  props: {
    group: {
      type: Number,
      default: 0,
    }
  },
  computed:{
    ...mapGetters({
      currentPage: 'status/newsCurrentPage',
      newsLists: 'users/newsList',
    }),
    ...mapState({
      getItems(state) {   //mapStateの中でthisを使う際にはアローはNG
        this.page.currentPage = state.status.newsCurrentPage[this.group] ? state.status.newsCurrentPage[this.group] : 1
        let current = this.page.currentPage * this.page.parPage
        let start = current - this.page.parPage
        let list = this.newsLists(this.group)
        return list.slice(start, current)
      },
    }),
    getPageCount: function() {
      let list = this.newsLists(this.group)
      return Math.ceil(list.length / this.page.parPage)
    }
  },
  components:{
    'paginate': Paginate,  //https://www.kabanoki.net/4320/
  },
  mounted(){
    this.init()
  },
  methods:{
    ...mapActions({
      setNewsCurrentPage: 'status/setNewsCurrentPage',
      setNewsList: 'users/setNewsList',
    }),
    init(){
      //グループ記事を登録
      this.setNewsList(this.group)
    },
    clickCallback: function (pageNum) {
      this.setNewsCurrentPage({ group: this.group, page: Number(pageNum) })
    },
  }
}
</script>

<style scoped>
  .newslist{
    padding-bottom: 10px;
  }
</style>